const breastSkin = [
    {
    label:"Side",
    controlType:"radio button",
    options:["Right", "Left", "Bilateral"]
    },

    {label:"Abnormality",
    controlType:"checkbox group",
    options:[ "redness", "swelling", "rash", "itching", "dimpling/ puckering", "scaling", "ulceration", "thickening"]
    },

    
    {label:"Other abnormality",
    controlType:"text area",
    options:[]
    },

    
    {label:"Underlying lump",
    controlType:"radio button",
    options:[ "Yes","No"]
    },

    { 
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }

]

export default breastSkin